// extracted by mini-css-extract-plugin
export default {"body":"table_body__YA+r5","btnContainer":"table_btnContainer__BTB0G","btn":"table_btn__jO4-6"};